module.exports = __webpack_public_path__ + "static/media/Gendry.38403bb9.jpg";